import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useContext } from 'react';
import { useSelector } from 'react-redux';
import { ProfileContext } from 'context';
import * as selectors from 'modules/PatientResults/selectors';
const PointSymbol = ({ size, color, borderColor, borderWidth, datum, activePointTS, trendData })=>{
    const profileContext = useContext(ProfileContext);
    const highlightedReadings = useSelector(profileContext.selectors.highlightedReadings);
    const selectedReading = useSelector(selectors.selectedReading);
    if (color === 'transparent') {
        return null;
    }
    const { manualReadings } = trendData;
    const selectedPointTS = selectedReading ? selectedReading.timestamp : 0;
    const x = datum.x;
    const isActive = activePointTS === x;
    const isSelected = selectedPointTS === x;
    size = isActive ? size * 1.4 : size;
    let point;
    if (manualReadings && manualReadings.includes(x)) {
        const highlight = highlightedReadings && highlightedReadings.some((item)=>item.timestamp === x);
        const halfSize = size / 2;
        point = /*#__PURE__*/ _jsxs("g", {
            transform: `translate(-${halfSize} -${halfSize}) rotate(45 ${halfSize} ${halfSize})`,
            children: [
                isSelected && /*#__PURE__*/ _jsx("rect", {
                    y: -halfSize,
                    x: -halfSize,
                    width: size + size,
                    height: size + size,
                    fill: color,
                    style: {
                        pointerEvents: 'none',
                        opacity: 0.3
                    }
                }),
                /*#__PURE__*/ _jsx("rect", {
                    width: size,
                    height: size,
                    fill: color,
                    stroke: highlight ? 'black' : borderColor,
                    strokeWidth: highlight ? 1 : borderWidth,
                    style: {
                        pointerEvents: 'none'
                    }
                })
            ]
        });
    } else if (borderColor === 'average') {
        return null;
    } else {
        const highlight = highlightedReadings && highlightedReadings.some((item)=>item.timestamp === x);
        point = /*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                isSelected && /*#__PURE__*/ _jsx("circle", {
                    r: size,
                    fill: color,
                    style: {
                        pointerEvents: 'none',
                        opacity: 0.3
                    }
                }),
                /*#__PURE__*/ _jsx("circle", {
                    r: size / 2,
                    fill: color,
                    stroke: highlight ? 'black' : borderColor,
                    strokeWidth: highlight ? 1 : borderWidth,
                    style: {
                        pointerEvents: 'none'
                    }
                })
            ]
        });
    }
    return /*#__PURE__*/ _jsx("g", {
        children: point
    });
};
export default PointSymbol;
